import { Text } from 'foundations-components/components/Text';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import RouterSideNavItem from 'ui-addon-react-router-dom/RouterSideNavItem';
import { useIsMobile } from '../../../hooks/useMedia';
import DesktopSideNav from './DesktopSideNav';
import MobileSideNav from './MobileSideNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SideNav({
  selectedNavItem,
  selectedItemLabel,
  menuAriaLabel,
  sections,
  footerSlot,
  desktopPosition = 'sticky',
  trackGlobalNavHeight = false,
  mobileMenuId,
  isMobile: isMobileProp
}) {
  const isMobileFromHook = useIsMobile();
  const isMobile = isMobileProp !== null && isMobileProp !== void 0 ? isMobileProp : isMobileFromHook;
  const navItems = sections.map((sectionConfig, index) => /*#__PURE__*/_jsx(RouterSideNav, {
    divider: index !== 0,
    headingText: sectionConfig.headingText,
    children: sectionConfig.items.map(item => /*#__PURE__*/_jsx(RouterSideNavItem, {
      "data-test-id": `side-nav-${item.navItem}`,
      "data-is-active": selectedNavItem === item.navItem,
      "data-selenium-class": "side-nav",
      active: selectedNavItem === item.navItem,
      title: /*#__PURE__*/_jsx(Text, {
        textWrap: "nowrap",
        children: item.title
      }),
      to: item.to,
      padding: "400",
      marginInlineStart: "300",
      onMouseEnter: item.onMouseEnter,
      onMouseLeave: item.onMouseLeave
    }, item.navItem))
  }, sectionConfig.section));
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileSideNav, {
      selectedItemLabel: selectedItemLabel,
      menuAriaLabel: menuAriaLabel,
      footerSlot: footerSlot,
      trackGlobalNavHeight: trackGlobalNavHeight,
      id: mobileMenuId,
      children: navItems
    });
  }
  return /*#__PURE__*/_jsxs(DesktopSideNav, {
    position: desktopPosition,
    children: [navItems, footerSlot]
  });
}
export default SideNav;